import {
  IContact,
  ContactFilters,
  GetContactsResponse,
  CreateContactRequest,
  UpdateContactRequest,
  BulkCreateContactsRequest,
  BulkCreateContactsResponse,
  ContactSegmentsFilters,
  GetContactSegmentsResponse,
  GetContactActivityResponse,
} from '../../types/contacts/contacts.types';
import { EmailSentHistoryFilters } from '../../types/emailSentHistory/emailSentHistory.types';
import { GetContactEmailsResponse } from '../../types/contacts/contacts.types';

// Action type constants
export const GET_CONTACTS_REQUEST = 'GET_CONTACTS_REQUEST';
export const GET_CONTACTS_SUCCESS = 'GET_CONTACTS_SUCCESS';
export const GET_CONTACTS_FAILURE = 'GET_CONTACTS_FAILURE';

export const GET_CONTACT_REQUEST = 'GET_CONTACT_REQUEST';
export const GET_CONTACT_SUCCESS = 'GET_CONTACT_SUCCESS';
export const GET_CONTACT_FAILURE = 'GET_CONTACT_FAILURE';

export const CREATE_CONTACT_REQUEST = 'CREATE_CONTACT_REQUEST';
export const CREATE_CONTACT_SUCCESS = 'CREATE_CONTACT_SUCCESS';
export const CREATE_CONTACT_FAILURE = 'CREATE_CONTACT_FAILURE';

export const UPDATE_CONTACT_REQUEST = 'UPDATE_CONTACT_REQUEST';
export const UPDATE_CONTACT_SUCCESS = 'UPDATE_CONTACT_SUCCESS';
export const UPDATE_CONTACT_FAILURE = 'UPDATE_CONTACT_FAILURE';

export const DELETE_CONTACT_REQUEST = 'DELETE_CONTACT_REQUEST';
export const DELETE_CONTACT_SUCCESS = 'DELETE_CONTACT_SUCCESS';
export const DELETE_CONTACT_FAILURE = 'DELETE_CONTACT_FAILURE';

export const CLEAR_CONTACT_STATE = 'CLEAR_CONTACT_STATE';

export const BULK_CREATE_CONTACTS_REQUEST = 'BULK_CREATE_CONTACTS_REQUEST';
export const BULK_CREATE_CONTACTS_SUCCESS = 'BULK_CREATE_CONTACTS_SUCCESS';
export const BULK_CREATE_CONTACTS_FAILURE = 'BULK_CREATE_CONTACTS_FAILURE';

export const BULK_DELETE_CONTACTS_REQUEST = 'BULK_DELETE_CONTACTS_REQUEST';
export const BULK_DELETE_CONTACTS_SUCCESS = 'BULK_DELETE_CONTACTS_SUCCESS';
export const BULK_DELETE_CONTACTS_FAILURE = 'BULK_DELETE_CONTACTS_FAILURE';
export const CLEAR_BULK_DELETE_CONTACTS_STATE =
  'CLEAR_BULK_DELETE_CONTACTS_STATE';

export const EXPORT_CONTACTS_CSV_REQUEST = 'EXPORT_CONTACTS_CSV_REQUEST';
export const EXPORT_CONTACTS_CSV_SUCCESS = 'EXPORT_CONTACTS_CSV_SUCCESS';
export const EXPORT_CONTACTS_CSV_FAILURE = 'EXPORT_CONTACTS_CSV_FAILURE';
export const CLEAR_EXPORT_STATE = 'CLEAR_EXPORT_STATE';

export const DELETE_ALL_CONTACTS_REQUEST = 'DELETE_ALL_CONTACTS_REQUEST';
export const DELETE_ALL_CONTACTS_SUCCESS = 'DELETE_ALL_CONTACTS_SUCCESS';
export const DELETE_ALL_CONTACTS_FAILURE = 'DELETE_ALL_CONTACTS_FAILURE';
export const CLEAR_DELETE_ALL_CONTACTS_STATE =
  'CLEAR_DELETE_ALL_CONTACTS_STATE';

// Contact Segments action types
export const GET_CONTACT_SEGMENTS_REQUEST = 'GET_CONTACT_SEGMENTS_REQUEST';
export const GET_CONTACT_SEGMENTS_SUCCESS = 'GET_CONTACT_SEGMENTS_SUCCESS';
export const GET_CONTACT_SEGMENTS_FAILURE = 'GET_CONTACT_SEGMENTS_FAILURE';

// Contact Activity action types
export const GET_CONTACT_ACTIVITY_REQUEST = 'GET_CONTACT_ACTIVITY_REQUEST';
export const GET_CONTACT_ACTIVITY_SUCCESS = 'GET_CONTACT_ACTIVITY_SUCCESS';
export const GET_CONTACT_ACTIVITY_FAILURE = 'GET_CONTACT_ACTIVITY_FAILURE';

// Contact Emails action types
export const GET_CONTACT_EMAILS_REQUEST = 'GET_CONTACT_EMAILS_REQUEST';
export const GET_CONTACT_EMAILS_SUCCESS = 'GET_CONTACT_EMAILS_SUCCESS';
export const GET_CONTACT_EMAILS_FAILURE = 'GET_CONTACT_EMAILS_FAILURE';

// Action interfaces
export interface GetContactsRequestAction {
  type: typeof GET_CONTACTS_REQUEST;
  payload: ContactFilters;
  [key: string]: any;
}

export interface GetContactsSuccessAction {
  type: typeof GET_CONTACTS_SUCCESS;
  payload: GetContactsResponse;
  [key: string]: any;
}

export interface GetContactsFailureAction {
  type: typeof GET_CONTACTS_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface GetContactRequestAction {
  type: typeof GET_CONTACT_REQUEST;
  payload: string;
  [key: string]: any;
}

export interface GetContactSuccessAction {
  type: typeof GET_CONTACT_SUCCESS;
  payload: IContact;
  [key: string]: any;
}

export interface GetContactFailureAction {
  type: typeof GET_CONTACT_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface CreateContactRequestAction {
  type: typeof CREATE_CONTACT_REQUEST;
  payload: CreateContactRequest;
  [key: string]: any;
}

export interface CreateContactSuccessAction {
  type: typeof CREATE_CONTACT_SUCCESS;
  payload: IContact;
  [key: string]: any;
}

export interface CreateContactFailureAction {
  type: typeof CREATE_CONTACT_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface UpdateContactRequestAction {
  type: typeof UPDATE_CONTACT_REQUEST;
  payload: UpdateContactRequest;
  [key: string]: any;
}

export interface UpdateContactSuccessAction {
  type: typeof UPDATE_CONTACT_SUCCESS;
  payload: IContact;
  [key: string]: any;
}

export interface UpdateContactFailureAction {
  type: typeof UPDATE_CONTACT_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface DeleteContactRequestAction {
  type: typeof DELETE_CONTACT_REQUEST;
  payload: string;
  [key: string]: any;
}

export interface DeleteContactSuccessAction {
  type: typeof DELETE_CONTACT_SUCCESS;
  payload: string;
  [key: string]: any;
}

export interface DeleteContactFailureAction {
  type: typeof DELETE_CONTACT_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearContactStateAction {
  type: typeof CLEAR_CONTACT_STATE;
  [key: string]: any;
}

export interface BulkCreateContactsRequestAction {
  type: typeof BULK_CREATE_CONTACTS_REQUEST;
  payload: BulkCreateContactsRequest;
  [key: string]: any;
}

export interface BulkCreateContactsSuccessAction {
  type: typeof BULK_CREATE_CONTACTS_SUCCESS;
  payload: BulkCreateContactsResponse;
  [key: string]: any;
}

export interface BulkCreateContactsFailureAction {
  type: typeof BULK_CREATE_CONTACTS_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface BulkDeleteContactsRequestAction {
  type: typeof BULK_DELETE_CONTACTS_REQUEST;
  payload: string[];
  [key: string]: any;
}

export interface BulkDeleteContactsSuccessAction {
  type: typeof BULK_DELETE_CONTACTS_SUCCESS;
  payload: string[];
  [key: string]: any;
}

export interface BulkDeleteContactsFailureAction {
  type: typeof BULK_DELETE_CONTACTS_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearBulkDeleteContactsStateAction {
  type: typeof CLEAR_BULK_DELETE_CONTACTS_STATE;
  [key: string]: any;
}

export interface ExportContactsCSVRequestAction {
  type: typeof EXPORT_CONTACTS_CSV_REQUEST;
  payload?: string;
  [key: string]: any;
}

export interface ExportContactsCSVSuccessAction {
  type: typeof EXPORT_CONTACTS_CSV_SUCCESS;
  payload: Blob;
  [key: string]: any;
}

export interface ExportContactsCSVFailureAction {
  type: typeof EXPORT_CONTACTS_CSV_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearExportStateAction {
  type: typeof CLEAR_EXPORT_STATE;
  [key: string]: any;
}

export interface DeleteAllContactsRequestAction {
  type: typeof DELETE_ALL_CONTACTS_REQUEST;
  [key: string]: any;
}

export interface DeleteAllContactsSuccessAction {
  type: typeof DELETE_ALL_CONTACTS_SUCCESS;
  [key: string]: any;
}

export interface DeleteAllContactsFailureAction {
  type: typeof DELETE_ALL_CONTACTS_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearDeleteAllContactsStateAction {
  type: typeof CLEAR_DELETE_ALL_CONTACTS_STATE;
  [key: string]: any;
}

// Contact Segments action interfaces
export interface GetContactSegmentsRequestAction {
  type: typeof GET_CONTACT_SEGMENTS_REQUEST;
  payload: {
    contactId: string;
    filters: ContactSegmentsFilters;
  };
  [key: string]: any;
}

export interface GetContactSegmentsSuccessAction {
  type: typeof GET_CONTACT_SEGMENTS_SUCCESS;
  payload: GetContactSegmentsResponse;
  [key: string]: any;
}

export interface GetContactSegmentsFailureAction {
  type: typeof GET_CONTACT_SEGMENTS_FAILURE;
  payload: string;
  [key: string]: any;
}

// Contact Activity action interfaces
export interface GetContactActivityRequestAction {
  type: typeof GET_CONTACT_ACTIVITY_REQUEST;
  payload: string; // contactId
  [key: string]: any;
}

export interface GetContactActivitySuccessAction {
  type: typeof GET_CONTACT_ACTIVITY_SUCCESS;
  payload: GetContactActivityResponse;
  [key: string]: any;
}

export interface GetContactActivityFailureAction {
  type: typeof GET_CONTACT_ACTIVITY_FAILURE;
  payload: string;
  [key: string]: any;
}

// Contact Emails action interfaces
export interface GetContactEmailsRequestAction {
  type: typeof GET_CONTACT_EMAILS_REQUEST;
  payload: {
    contactId: string;
    filters: EmailSentHistoryFilters;
  };
  [key: string]: any;
}

export interface GetContactEmailsSuccessAction {
  type: typeof GET_CONTACT_EMAILS_SUCCESS;
  payload: GetContactEmailsResponse;
  [key: string]: any;
}

export interface GetContactEmailsFailureAction {
  type: typeof GET_CONTACT_EMAILS_FAILURE;
  payload: string;
  [key: string]: any;
}

// Union type for all contact actions
export type ContactsActionTypes =
  | GetContactsRequestAction
  | GetContactsSuccessAction
  | GetContactsFailureAction
  | GetContactRequestAction
  | GetContactSuccessAction
  | GetContactFailureAction
  | CreateContactRequestAction
  | CreateContactSuccessAction
  | CreateContactFailureAction
  | UpdateContactRequestAction
  | UpdateContactSuccessAction
  | UpdateContactFailureAction
  | DeleteContactRequestAction
  | DeleteContactSuccessAction
  | DeleteContactFailureAction
  | ClearContactStateAction
  | BulkCreateContactsRequestAction
  | BulkCreateContactsSuccessAction
  | BulkCreateContactsFailureAction
  | BulkDeleteContactsRequestAction
  | BulkDeleteContactsSuccessAction
  | BulkDeleteContactsFailureAction
  | ClearBulkDeleteContactsStateAction
  | ExportContactsCSVRequestAction
  | ExportContactsCSVSuccessAction
  | ExportContactsCSVFailureAction
  | ClearExportStateAction
  | DeleteAllContactsRequestAction
  | DeleteAllContactsSuccessAction
  | DeleteAllContactsFailureAction
  | ClearDeleteAllContactsStateAction
  | GetContactSegmentsRequestAction
  | GetContactSegmentsSuccessAction
  | GetContactSegmentsFailureAction
  | GetContactActivityRequestAction
  | GetContactActivitySuccessAction
  | GetContactActivityFailureAction
  | GetContactEmailsRequestAction
  | GetContactEmailsSuccessAction
  | GetContactEmailsFailureAction;
